module.exports = __webpack_public_path__ + "img/1F1F8-1F1F2.79e9a96b.svg";